<template>
  <div id="analytics-dashboard">
    <!-- Row 1: KPI Cards -->
    <analytics-kpi-cards v-if="kpiSummary" :data="kpiSummary" class="mb-8" />

    <!-- Row 2: Revenue by Payment Method (full width) -->
    <div class="mb-8" v-if="revenueByPayment">
      <analytics-revenue-by-payment />
    </div>

    <!-- Row 3: Weekday x Hour Heatmap -->
    <div class="mb-8" v-if="weekdayHeatmap">
      <analytics-weekday-heatmap />
    </div>

    <!-- Row 4: Orders + Avg Order Value (combined) -->
    <div class="mb-8" v-if="avgOrderValue">
      <analytics-orders-and-avg />
    </div>

    <!-- Row 5: New vs Returning Customers -->
    <div class="mb-8" v-if="newVsReturning">
      <analytics-new-vs-returning />
    </div>

    <!-- Row 6: Best Sellers + Popular Ingredients -->
    <div class="flex flex-wrap -mx-2 mb-8 items-stretch">
      <div class="w-full lg:w-1/3 px-2 mb-4 lg:mb-0 flex">
        <analytics-best-sellers v-if="productPerformance" class="w-full" />
      </div>
      <div class="w-full lg:w-2/3 px-2 flex">
        <analytics-popular-ingredients
          v-if="popularIngredients"
          class="w-full"
        />
      </div>
    </div>

    <!-- Row 7: Payment Methods + Customer & Ops -->
    <div class="flex flex-wrap -mx-2 mb-8 items-stretch">
      <div class="w-full lg:w-1/3 px-2 mb-4 lg:mb-0 flex">
        <analytics-payment-methods v-if="paymentMethods" class="w-full" />
      </div>
      <div class="w-full lg:w-2/3 px-2 flex">
        <analytics-customer-and-ops
          v-if="customerStats && operations"
          :customer-data="customerStats"
          :ops-data="operations"
          class="w-full"
        />
      </div>
    </div>

    <!-- Row 8: Top Customers -->
    <div class="mb-8" v-if="customerStats">
      <analytics-top-customers />
    </div>

    <!-- Row 9: Revenue by Area + Order Map -->
    <div class="flex flex-wrap -mx-2 mb-8 items-stretch">
      <div class="w-full lg:w-1/2 px-2 mb-4 lg:mb-0 flex">
        <analytics-revenue-by-area v-if="revenueByArea" class="w-full" />
      </div>
      <div class="w-full lg:w-1/2 px-2 flex">
        <analytics-order-heatmap v-if="addressMap" class="w-full" />
      </div>
    </div>

    <!-- Row 10: Churned Customers -->
    <div class="mb-8">
      <analytics-churned-customers />
    </div>
  </div>
</template>

<script>
import AnalyticsKpiCards from "@/components/analytics/AnalyticsKpiCards.vue";
import AnalyticsRevenueByPayment from "@/components/analytics/AnalyticsRevenueByPayment.vue";
import AnalyticsWeekdayHeatmap from "@/components/analytics/AnalyticsWeekdayHeatmap.vue";
import AnalyticsOrdersAndAvg from "@/components/analytics/AnalyticsOrdersAndAvg.vue";
import AnalyticsNewVsReturning from "@/components/analytics/AnalyticsNewVsReturning.vue";
import AnalyticsBestSellers from "@/components/analytics/AnalyticsBestSellers.vue";
import AnalyticsPopularIngredients from "@/components/analytics/AnalyticsPopularIngredients.vue";
import AnalyticsPaymentMethods from "@/components/analytics/AnalyticsPaymentMethods.vue";
import AnalyticsCustomerAndOps from "@/components/analytics/AnalyticsCustomerAndOps.vue";
import AnalyticsTopCustomers from "@/components/analytics/AnalyticsTopCustomers.vue";
import AnalyticsRevenueByArea from "@/components/analytics/AnalyticsRevenueByArea.vue";
import AnalyticsOrderHeatmap from "@/components/analytics/AnalyticsOrderHeatmap.vue";
import AnalyticsChurnedCustomers from "@/components/analytics/AnalyticsChurnedCustomers.vue";

export default {
  components: {
    AnalyticsKpiCards,
    AnalyticsRevenueByPayment,
    AnalyticsWeekdayHeatmap,
    AnalyticsOrdersAndAvg,
    AnalyticsNewVsReturning,
    AnalyticsBestSellers,
    AnalyticsPopularIngredients,
    AnalyticsPaymentMethods,
    AnalyticsCustomerAndOps,
    AnalyticsTopCustomers,
    AnalyticsRevenueByArea,
    AnalyticsOrderHeatmap,
    AnalyticsChurnedCustomers,
  },
  computed: {
    kpiSummary() {
      return this.$store.state.analytics.kpiSummary;
    },
    productPerformance() {
      return this.$store.state.analytics.productPerformance;
    },
    paymentMethods() {
      return this.$store.state.analytics.paymentMethods;
    },
    customerStats() {
      return this.$store.state.analytics.customerStats;
    },
    operations() {
      return this.$store.state.analytics.operations;
    },
    revenueByPayment() {
      return this.$store.state.analytics.revenueByPayment;
    },
    weekdayHeatmap() {
      return this.$store.state.analytics.weekdayHeatmap;
    },
    avgOrderValue() {
      return this.$store.state.analytics.avgOrderValue;
    },
    newVsReturning() {
      return this.$store.state.analytics.newVsReturning;
    },
    popularIngredients() {
      return this.$store.state.analytics.popularIngredients;
    },
    revenueByArea() {
      return this.$store.state.analytics.revenueByArea;
    },
    addressMap() {
      return this.$store.state.analytics.addressMap;
    },
  },
  created() {
    this.$store.dispatch("analytics/fetchAllAnalytics");
  },
};
</script>
